module.exports = __webpack_public_path__ + "img/kr.6031b375.svg";